import { render, staticRenderFns } from "./ContractDocumentEdoTable.vue?vue&type=template&id=b467bb20&"
import script from "./ContractDocumentEdoTable.vue?vue&type=script&lang=ts&"
export * from "./ContractDocumentEdoTable.vue?vue&type=script&lang=ts&"
import style0 from "./ContractDocumentEdoTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports